import { hasProp } from './has-prop';

export function propEquals<K extends PropertyKey, V>(obj: unknown, key: K, value: V): obj is Record<K, V> {
    return hasProp(obj, key) && obj[key] === value;
}
